import * as React from 'react';
import { BowtieTranslation } from '../../constants';
import { InspectionEvaluations } from '../../types-store';
import { TooltipEvaluations } from './tooltip-evaluations';

interface TooltipEvaluationsSectionProps {
  caseNumber: number;
  inspectionEvaluations: InspectionEvaluations;
  translation: BowtieTranslation;
}

export const TooltipEvaluationsSection: React.FC<TooltipEvaluationsSectionProps> = ({
  caseNumber, inspectionEvaluations, translation
}) => {
  const evaluation = inspectionEvaluations.evaluationStatuses[caseNumber] || [];
  const fetchingEvaluation = !!inspectionEvaluations.fetching
    && inspectionEvaluations.fetching.some(c => c === caseNumber);

  return <TooltipEvaluations
    caseNumber={caseNumber}
    evaluation={evaluation}
    fetching={fetchingEvaluation}
    translation={translation} />;
};
